import {b as b$1}from'./chunk-QUNSUFAY.mjs';import {i,h,e,d,a,b,g as g$1,j}from'./chunk-OT7EVHXX.mjs';import {STYLE_DEVICE,APPEARANCE}from'@lyteflo/types';import s from'colorjs.io';function c({r:o,g:e,b:n},t){return `rgba(${o}, ${e}, ${n}, ${t})`}var bt=(o,e,n)=>{let t=new s(o).to("oklch"),a=e<0?t.l+e:e,r=n>t.c?t.c:n;return t.set({l:a,c:r}),t},Z=(o,e)=>Object.keys(e).map(n=>{let t=e[Number(n)];return bt(o,t.l,t.c)}),_=".lf-widget.light, .lf-widget.light-theme, .light, .light-theme",T=".lf-widget.dark, .lf-widget.dark-theme, .dark, .dark-theme",tt=`${_}, ${T}`,kt=4.5;function g(o){let e=new s(o),n=s.contrast(e,new s(i),"WCAG21");if(n>=kt)return i;let t=s.contrast(e,new s(h),"WCAG21");return n>=t?i:h}function Ot(o,e){if(o)try{return g(o)}catch{return e}return e}var ot=o=>o===h?i:h;function Tt(o,e){try{let n=g(o);return `
${_} {
  --green-contrast: ${n};
  --green-surface: ${ot(n)};
}

${T} {
  --green-contrast: ${n};
}

${tt} {
  --lyteflo-cta-contrast: ${g(e)};
}
`}catch{return ""}}async function It(o,e){let n=new s(o).to("oklch"),t="green",a$1=Z(o,a),r=Z(o,b),$=a$1[0],l=a$1[1],u=a$1[2],S=a$1[3],b$1=a$1[4],k=a$1[5],A=a$1[6],p=a$1[7],d=a$1[8],w=a$1[9],C=a$1[10],x=a$1[11],i=St=>{let O=new s(o).to("p3");return `color(display-p3 ${O.r.toFixed(4)} ${O.g.toFixed(4)} ${O.b.toFixed(4)} / ${St})`},I=i(.012),L=i(.032),j=i(.079),P=i(.134),N=i(.185),v=i(.244),G=i(.314),E=i(.412),M=E,V=i(.455),Y=i(.648),F=i(.875),rt=c(n,.02),st=c(n,.05),at=c(n,.15),$t=c(n,.25),ct=c(n,.35),it=c(n,.45),lt=c(n,.55),dt=c(n,.65),gt=c(n,.75),ut=c(n,.85),pt=c(n,.95),yt=c(n,.975),K=new s(o).luminance,f=g(o),W=ot(f),ft=g(e),ht=K<.5?d.to("srgb").toString({format:"hex"}):"#8D8D8D",mt=K>.5?d.to("srgb").toString({format:"hex"}):"#8D8D8D";return `


${_} {
  ${t}-1: ${$.to("srgb").toString({format:"hex"})};
  ${t}-2: ${l.to("srgb").toString({format:"hex"})};
  ${t}-3: ${u.to("srgb").toString({format:"hex"})};
  ${t}-4: ${S.to("srgb").toString({format:"hex"})};
  ${t}-5: ${b$1.to("srgb").toString({format:"hex"})};
  ${t}-6: ${k.to("srgb").toString({format:"hex"})};
  ${t}-7: ${A.to("srgb").toString({format:"hex"})};
  ${t}-8: ${p.to("srgb").toString({format:"hex"})};
  ${t}-9: ${d.to("srgb").toString({format:"hex"})};
  ${t}-10: ${w.to("srgb").toString({format:"hex"})};
  ${t}-11: ${C.to("srgb").toString({format:"hex"})};
  ${t}-12: ${x.to("srgb").toString({format:"hex"})};
  
  ${t}-a1: ${rt};
  ${t}-a2: ${st};
  ${t}-a3: ${at};
  ${t}-a4: ${$t};
  ${t}-a5: ${ct};
  ${t}-a6: ${it};
  ${t}-a7: ${lt};
  ${t}-a8: ${dt};
  ${t}-a9: ${gt};
  ${t}-a10: ${ut};
  ${t}-a11: ${pt};
  ${t}-a12: ${yt};
  ${t}-contrast: ${f};
  ${t}-surface: ${W};
  ${t}-indicator: ${o};
  ${t}-track: ${o};

  --${t}-1: ${$};
  --${t}-2: ${l};
  --${t}-3: ${u};
  --${t}-4: ${S};
  --${t}-5: ${b$1};
  --${t}-6: ${k};
  --${t}-7: ${A};
  --${t}-8: ${p};
  --${t}-9: ${d};
  --${t}-10: ${w};
  --${t}-11: ${C};
  --${t}-12: ${x};

  --${t}-a1: ${I};
  --${t}-a2: ${L};
  --${t}-a3: ${j};
  --${t}-a4: ${P};
  --${t}-a5: ${N};
  --${t}-a6: ${v};
  --${t}-a7: ${G};
  --${t}-a8: ${E};
  --${t}-a9: ${M};
  --${t}-a10: ${V};
  --${t}-a11: ${Y};
  --${t}-a12: ${F};

  --${t}-contrast: ${f};
  --${t}-surface: ${W};
  --${t}-indicator: ${p};
  --${t}-track: ${p};
  --lyteflo-attribute-icon-stroke: ${ht};
}

${T} {
  --${t}-1: ${r[0]};
  --${t}-2: ${r[1]};
  --${t}-3: ${r[2]};
  --${t}-4: ${r[3]};
  --${t}-5: ${r[4]};
  --${t}-6: ${r[5]};
  --${t}-7: ${r[6]};
  --${t}-8: ${r[7]};
  --${t}-9: ${r[8]};
  --${t}-10: ${r[9]};
  --${t}-11: ${r[10]};
  --${t}-12: ${r[11]};

  --${t}-a1: ${I};
  --${t}-a2: ${L};
  --${t}-a3: ${j};
  --${t}-a4: ${P};
  --${t}-a5: ${N};
  --${t}-a6: ${v};
  --${t}-a7: ${G};
  --${t}-a8: ${E};
  --${t}-a9: ${M};
  --${t}-a10: ${V};
  --${t}-a11: ${Y};
  --${t}-a12: ${F};

  --${t}-contrast: ${f};
  --${t}-surface: ${r[1]};
  --${t}-indicator: ${r[8]};
  --${t}-track: ${r[8]};
  --lyteflo-attribute-icon-stroke: ${mt};
}

${tt} {
  --lyteflo-cta: ${e};
  --lyteflo-cta-contrast: ${ft};
}

@supports (color: color(display-p3 1 1 1)) {
  @media (color-gamut: p3) {
    ${_} {
      --${t}-1: ${new s($).to("oklch")};
      --${t}-2: ${new s(l).to("oklch")};
      --${t}-3: ${new s(u).to("oklch")};
      --${t}-4: ${new s(S).to("oklch")};
      --${t}-5: ${new s(b$1).to("oklch")};
      --${t}-6: ${new s(k).to("oklch")};
      --${t}-7: ${new s(A).to("oklch")};
      --${t}-8: ${new s(p).to("oklch")};
      --${t}-9: ${new s(d).to("oklch")};
      --${t}-10: ${new s(w).to("oklch")};
      --${t}-11: ${new s(C).to("oklch")};
      --${t}-12: ${new s(x).to("oklch")};

      --${t}-a1: ${new s($).to("p3")};
      --${t}-a2: ${new s(l).to("p3")};
      --${t}-a3: ${new s(u).to("p3")};
      --${t}-a4: ${new s(S).to("p3")};
      --${t}-a5: ${new s(b$1).to("p3")};
      --${t}-a6: ${new s(k).to("p3")};
      --${t}-a7: ${new s(A).to("p3")};
      --${t}-a8: ${new s(p).to("p3")};
      --${t}-a9: ${new s(d).to("p3")};
      --${t}-a10: ${new s(w).to("p3")};
      --${t}-a11: ${new s(C).to("p3")};
      --${t}-a12: ${new s(x).to("p3")};

      --${t}-contrast: ${f};
      --${t}-surface: ${W};
      --${t}-indicator: ${new s(d).to("oklch")};
      --${t}-track: ${new s(d).to("oklch")};
    }
  }
}
`}var wt="medium",D=o=>{if(typeof o=="string")try{return D(JSON.parse(o))}catch{return {}}return o&&typeof o=="object"&&!Array.isArray(o)?o:{}},et=(o,e)=>typeof o=="string"&&b$1(o)?o:e,Ct=o=>String(D(o).cssStyling??""),Gt=o=>{let{accentColor:e$1,ctaColor:n,radius:t,appearance:a}=D(o);return {accentColor:et(e$1,j),ctaColor:et(n,g$1),radius:d.find(r=>r===t)??wt,appearance:e.find(r=>r===a)??APPEARANCE.LIGHT}},Mt=({accentColor:o,ctaColor:e,radius:n,appearance:t},{loaded:a,cssStyling:r}={})=>{let $=D(a);return {...$,accentColor:o,accentContrast:g(o),ctaColor:e,cssStyling:r??Ct($),radius:n,appearance:t}};var R="shared_styles",y="mobile_style";function B(o){if(o!=null){if(typeof o=="string")try{let e=JSON.parse(o);return e&&typeof e=="object"&&!Array.isArray(e)?e:void 0}catch{return}if(typeof o=="object"&&!Array.isArray(o))return o}}var xt=o=>o!=null&&typeof o=="object"&&!Array.isArray(o),_t=o=>!!o&&Object.keys(o).length>0;function Dt(o){let e=B(o.style);if(!e||!(y in e))return o;let{[y]:n,...t}=e;return {...o,style:t,mobile_style:o.mobile_style??(xt(n)?n:void 0)}}function Yt(o){let e=B(o.style),n=o.widgets?.map(Dt),t=!!n?.some((l,u)=>l!==o.widgets[u]),a=t?n:o.widgets;if(!e||!(R in e))return t?{...o,widgets:a}:o;let{[R]:r,...$}=e;return {...o,style:$,shared_styles:o.shared_styles??(Array.isArray(r)?r:void 0),widgets:a}}function Rt(o){let{mobile_style:e,...n}=o,t=B(o.style);if(!_t(e)){if(!t||!(y in t))return e===void 0?o:n;let{[y]:$,...l}=t;return {...n,style:l}}let{[y]:a,...r}=t??{};return {...n,style:{...r,[y]:e}}}function Ft(o){let{shared_styles:e,...n}=o,t=B(o.style)??{},{[R]:a,...r}=t,$=e&&e.length>0?{...r,[R]:e}:r;return {...n,style:$,widgets:o.widgets?.map(Rt)}}var Bt=(o,e)=>(o??[]).filter(n=>n.appliesToAll||(n.widgetNames??[]).includes(e)),Jt=(o,e,n=STYLE_DEVICE.DESKTOP)=>{let t=n===STYLE_DEVICE.MOBILE,a={};for(let r of Bt(o.shared_styles,e.name))a={...a,...r.style},t&&r.mobile_style&&(a={...a,...r.mobile_style});return a={...a,...e.style??{}},t&&e.mobile_style&&(a={...a,...e.mobile_style}),a};export{g as a,Ot as b,Tt as c,It as d,wt as e,Ct as f,Gt as g,Mt as h,Yt as i,Ft as j,Bt as k,Jt as l};//# sourceMappingURL=chunk-UV5CK66E.mjs.map
//# sourceMappingURL=chunk-UV5CK66E.mjs.map